export default "__VITE_ASSET__N6LRfLEfghGa73qxwBQcwg__";